import React, {useEffect, useState} from 'react';
import {useParams, useNavigate} from "react-router-dom";
import {ApiService} from 'lib/http.service';
import {env} from '../../../constants/global.vars';
import {auth} from '../../../store/auth.store';
import {Storage} from '../../../services/localstorege.service';
import _ from 'lodash';
import {gtmSelectItem, gtmViewItemList} from '../../../services/misc.functions';
import iconRight from "../../../assets/feather/arrow-right.svg";
import paths from "../../../paths";

const NumericGamePlayer = ({slug, slug2}: { slug: string, slug2: string }) => {
    const accountId = auth?.member?.id;
    const userToken = auth?.token;

    const queryParams = new URLSearchParams({
        slug: slug,
        userToken: userToken || '',
        accountId: String(accountId || ''),
        isTest: window.location.origin.includes('test') || window.location.origin.includes('localhost') ? "true" : "false",
        isResults: slug2 === "cekilis-sonuclari" ? "true" : "false",
    });

    const widgetUrl = `${window.location.origin}/numeric-game-widget/numeric-game-widget.html?${queryParams.toString()}`;

    return (
        <div className="page-widget numeric-game-page" style={{minHeight: '80vh', height: '100%'}}>
            <iframe
                title="Sisal Numeric Game Loader"
                src={widgetUrl}
                style={{width: '100%', height: '100%', border: 'none', minHeight: '80vh'}}
                allow="fullscreen; autoplay"
            />
        </div>
    );
};

export default function NumericGames() {
    const params = useParams();
    const activeSlug = params.subpage;
    const activeSlug2 = params.subpage2;
    const navigate = useNavigate();
    const [gamesList, setGamesList] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getGames = async () => {
            let games;
            if (!games) {
                const res: any = await new ApiService().start("post", env.accounting_api + "/games/api/list-game/", {
                    vendor: 7
                }, false);
                if (res && res.status) {
                    games = _.orderBy(res.data, ["ordering"], "asc");
                }
            }
            const filtered = (games || []).filter((g: any) => g.vendor === 7);
            setGamesList(filtered);
            gtmViewItemList(filtered, "Oyun");
            setLoading(false);
        };
        getGames();
    }, []);

    if (activeSlug) {
        return <NumericGamePlayer slug={activeSlug} slug2={activeSlug2 || ''}/>;
    }

    return (
        <div className="page-widget">
            <svg style={{display: "none"}}>
                <defs>
                    <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"></path>
                </defs>
            </svg>
            <div className={"tab-scroll"}>
                {/* Tab Header */}
                <ul className="nav nav-tabs">
                    <li
                        key={`tabs`}
                        className={`nav-item active`}
                    >
                        <svg className="left" viewBox="0 0 80 60" preserveAspectRatio="none">
                            <use xlinkHref="#tabshape"></use>
                        </svg>
                        <a className="nav-link" id={`011`}>
                            Sayısal Oyunlar
                        </a>
                        <svg className="right" viewBox="0 0 80 60" preserveAspectRatio="none">
                            <use xlinkHref="#tabshape"></use>
                        </svg>
                    </li>
                </ul>
            </div>

            {loading ? (
                <div className="text-white px-4">Oyunlar yükleniyor...</div>
            ) : (
                <div className="row m-2">
                    {gamesList.map((game: any, key: number) => {
                        const isRemanded = game.is_active === false && auth.member?.id && auth.remaining_games.includes(game.id);
                        const statusClass = game.is_active ? "playable" : (isRemanded ? "remanded" : "");

                        return (
                            <div key={`games-list-${key}`} className="col-6 col-lg-3 mb-4">
                                <div className="game-widget">
                                    <img
                                        className="games pointer"
                                        src={`${env.cdn_host}/media/${game.image}`}
                                        style={{objectFit: 'fill'}}
                                        alt={game.name}
                                        onClick={() => {
                                            if (game.is_active) {
                                                navigate(`${paths.numericgames.url}/${game.code}`);
                                                gtmSelectItem([game], "Oyunlar");
                                            }
                                        }}
                                    />
                                    {/*<h2 className="title">{game.name}</h2>*/}
                                    <div className={`${statusClass} body mt-2`}>
                                        {game.is_active ? (
                                            <>
                                                <span
                                                    className="label text-decoration-none text-black pointer"
                                                    onClick={() => {
                                                        navigate(`${paths.numericgames.url}/${game.code}`);
                                                        gtmSelectItem([game], "Oyunlar");
                                                    }}
                                                >
                                                    Hemen Oyna
                                                </span>
                                            </>
                                        ) : (
                                            <span className="label pointer">
                                                {isRemanded ? "✅ Hatırlatıcı kuruldu" : "⏰ Hatırlat"}
                                            </span>
                                        )}
                                    </div>

                                    {game.is_active &&
                                        <p
                                            className={"text-center text-decoration-underline p-2 cursor-pointer m-0 mb-0"}
                                            onClick={() => {
                                                navigate(`${paths.numericgames.url}/${game.code}/cekilis-sonuclari`);
                                                gtmSelectItem([game], "Oyunlar");
                                            }}
                                        >
                                            Sonuçlar
                                        </p>
                                    }
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
